import { IconProps } from "../../types/icon";

export default function AddIcon ({className = ""}: IconProps) {
  return (
    <svg className={className} width="18.22" height="18.22" viewBox="0 0 18.22 18.22">
      <g>
        <path d="M0,9.11a9.11,9.11,0,1,1,9.11,9.11A9.11,9.11,0,0,1,0,9.11M9.11,1.518A7.592,7.592,0,1,0,16.7,9.11,7.591,7.591,0,0,0,9.11,1.518m0,3.8a.759.759,0,0,1,.759.759V8.351h2.277a.759.759,0,0,1,0,1.518H9.869v2.277a.759.759,0,0,1-1.518,0V9.869H6.073a.759.759,0,1,1,0-1.518H8.351V6.073a.759.759,0,0,1,.759-.759" fill="currentColor" fillRule="evenodd"/>
      </g>
    </svg>
  )
}